module.exports = __webpack_public_path__ + "videoThumbnailRectangle.jpg";